'use client'

import { useEffect } from 'react'
import { DeadpoolUser } from '~types/index'

const useClarityIdentify = (customer: DeadpoolUser | null) => {
  useEffect(() => {
    if (!customer?.email || typeof window === 'undefined' || !window.clarity) {
      return
    }

    const identifyUser = async () => {
      try {
        // Generate a unique session ID for this session
        const sessionId = `session-${Date.now()}-${Math.random()
          .toString(36)
          .substr(2, 9)}`

        // Generate a unique page ID for the current page
        const pageId = `page-${window.location.pathname.replace(
          /\//g,
          '-'
        )}-${Date.now()}`

        // Use the customer's name as friendly name, fallback to email prefix
        const friendlyName =
          customer.name || customer.id || customer.email.split('@')[0]

        const result = await window.clarity(
          'identify',
          customer.email,
          sessionId,
          pageId,
          friendlyName
        )

        console.log('Clarity user identified:', result)
      } catch (error) {
        console.error('Failed to identify user in Clarity:', error)
      }
    }

    identifyUser()
  }, [customer])
}

export default useClarityIdentify
